import React, { useState, useContext, useEffect } from 'react'
import infJoin from "../../../Image/infJoin.png"
import infJoinM from "../../../Image/MobileVersion/infJoinM.png"
import { Link, useNavigate } from "react-router-dom";
import { APIRequest, ApiUrl } from '../../../Helpers/ApiHelper';
import customValidation from '../../../Helpers/customValidation';
import colourStyles from '../../../Helpers/colourStyles';
import { Placeholder, SelectPicker } from 'rsuite';
import { DatePicker } from 'rsuite';
import { Notification, useToaster } from 'rsuite';
import { Auth } from '../../../Contexts/AuthContext';
import hasError from '../../../Helpers/ErrorHelper';
import CustomLoader from '../../comman/Loader/CustomLoader';
// import DatePicker from 'react-date-picker';
import backButton from "../../../Image/backButton.svg"
import dreamstars_logo from "../../../Image/dreamstars_logo.png"
import { addYears } from 'date-fns';
import Footer from '../../comman/Footer';
import Select from 'react-select';
import useWindowWidth from '../../comman/UseWindowWidth';



const InfluencerJoin = () => {
  const [countries, setCountries] = useState([]);
  const navigate = useNavigate();
  const { formData, setFormData } = useContext(Auth);
  const [isLoading, setIsLoading] = useState(false);

  const [validataionErrors, setValidataionErrors] = useState([]);
  const toaster = useToaster();
  const [check , setCheck]=useState(false);



  useEffect(() => {
    getCountries();
  }, [])

  const moveToNextStep = (e) => {
    e.preventDefault();

    const config = {

      url: ApiUrl.infulencerValidateBasicData,

      method: 'POST',
      body: {
        email: formData?.email,
        password: formData?.password,
        name: formData?.name,
        gender: formData?.gender.value,
        phone: formData?.phone,
        dob: formData?.dob,
        country_id: formData?.country_id?.value,
        tos: formData?.tos
      }

    }

    APIRequest(
      config,
      res => {
        if (res?.status) {
          const loginData = {
            influencer_id: res?.influencer,
          }
          navigate('/connect-platform', { state: loginData })
        }
      },

      err => {
        if (err.response.status === 422) {
          setValidataionErrors(err.response.data.errors);
        }
        if (err.response.status === 444) {
          toaster.push(<Notification type="error" header="Error" >
            <Placeholder.Paragraph style={{ width: 100, color: 'red' }} rows={0} /> {err?.response?.data?.message}</Notification>
            , {
              placement: 'topEnd'
            });

        }
      }
    )

  }

  const CalendarIcon = () => {
    return (
      <svg width="1em" height="1em" viewBox="0 0 14 14" fill="currentColor" aria-hidden="true" focusable="false" className="rs-picker-toggle-caret rs-icon" aria-label="calendar" ><path d="M1 4v8.5a.5.5 0 00.5.5H8c0-.128.049-.256.146-.354.555-.555.854-1.6.854-3.146a.5.5 0 01.621-.485l.119.03A2.623 2.623 0 0012.999 6.5V4h-12zm3-2h6V0h1v2h1.5A1.5 1.5 0 0114 3.5v3a3.623 3.623 0 01-4.015 3.603c-.064 1.245-.335 2.212-.831 2.898H12.5a.5.5 0 00.5-.5v-2a.5.5 0 011 0v2a1.5 1.5 0 01-1.5 1.5h-11a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5H3v-2h1v2zm5 4V5h1v1h2v1h-2v1H9V7H7v2h1v1H7v2H6v-2H4v2H3v-2H1V9h2V7H1V6h2V5h1v1h2V5h1v1h2zM6 9V7H4v2h2z"></path></svg>
    )
  }




  const getCountries = () => {
    let config = {
      url: ApiUrl.countries,
      method: 'GET',
      body: {},
    };

    APIRequest(
      config,

      res => {
        setCountries(res.data)

      },
      err => {

      },
    );
  }
  const sources = ["Male", "Female", "Others"];



  const changeInput = (e) => {

    const name = e.target.name;

    if (name === 'phone') {
      if (!customValidation.isPositveIntegerNumber(e?.target?.value)) {
        return false;
      }
    } else if (name === 'name') {
      if (!customValidation.isAlphabet(e?.target?.value)) {
        return false;
      }

    }

    
    let value;
    if (name === 'tos') {
      value = e.target.checked 
    } else {
      value = e.target.value;
    }
    
    const collect = {
      ...formData,
      [name]: value,

    };
    
    
    const IsError = validataionErrors?.find(v => v.field == name);


    if (IsError !== undefined) {
      const errors = validataionErrors?.filter(v => v.field != name);
      setValidataionErrors(errors);
    }
  setFormData(collect);

  }

  const handleOnChange = (value) => {

    const collect = {
      ...formData,
      'country_id': value,
    };
    setFormData(collect);
  }

  function formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }

  const handleOnDateChange = (name, value) => {
  const sortDate = value !== undefined ? new Date(value).toString().slice(0, 15) : '';
    const updatedDate = formatDate(sortDate);
    const collect = {
      ...formData,
      [name]: updatedDate
    };


    const IsError = validataionErrors?.find(v => v.field === 'dob');
    if (IsError !== undefined) {
      const errors = validataionErrors?.filter(v => v.field !== 'dob');
      setValidataionErrors(errors);
    }
    setFormData(collect);

  }


  const handleOnKnownSource = (val) => {

    const collect = {
      ...formData,
      'gender': val,

    };

    const IsError = validataionErrors?.find(v => v.field === 'gender');
    if (IsError !== undefined) {
      const errors = validataionErrors?.filter(v => v.field !== 'gender');
      setValidataionErrors(errors);
    }
    setFormData(collect);
  }

  const basicDetails = () => {
    return (
      <>
        <form className='mt-10 flex flex-col items-center justify-around  w-[300px] sm:w-[440px] lg:w-[480px] font-museob ' >


          <div className='w-full' >
            <input style={{ boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px' }}
              onChange={changeInput} type="email" name="email" id="email" value={formData?.email} placeholder="Email Address"
              className="border-none outline-none rounded-lg w-full h-[47px] placeholder:text-slate-300"
            ></input>
            {hasError(validataionErrors, "email")}
          </div>

          <div className='w-full my-3' >
            <input style={{ boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px' }}
              onChange={changeInput} value={formData?.password} type="password" name="password" id="password" placeholder="Password"
              className="border-none outline-none rounded-lg w-full h-[47px] placeholder:text-slate-300"></input>
            {hasError(validataionErrors, "password")}
          </div>


          <div className='w-full ' >
            <input style={{ boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px' }}
              onChange={changeInput} value={formData?.name} type="text" pattern="[A-Za-z]" name="name" id="name" placeholder="Your Full Name"
              className="border-none outline-none rounded-lg w-full h-[47px]   placeholder:text-slate-300"></input>

            {hasError(validataionErrors, "name")}
          </div>

          <div className='w-full my-3 '>
            <input style={{ boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px' }}
              onChange={changeInput} pattern="/^\d+$/" value={formData?.phone != undefined ? formData?.phone : ''} type="text" name="phone" id="phone" placeholder="Your number"
              className="border-none outline-none rounded-lg w-full h-[47px] placeholder:text-slate-300"></input>
            {hasError(validataionErrors, "phone")}
          </div>

          <div className='w-full  ' >

            <Select
              className="joinClass sbar"
              classNamePrefix="joinChild sbar"
              placeholder="Country"
              styles={colourStyles}
              isClearable={true}
              // defaultValue={formData?.country_id !== undefined ? formData?.country_id : ''}
              value={formData?.country_id !== undefined ? formData?.country_id : ''}
              onChange={(value) => handleOnChange(value)}
              options={countries?.map(item => ({ label: item?.name, value: item?.id }))}

            />
            {hasError(validataionErrors, "country_id")}
          </div>


          <div className='w-full my-3 ' >

            <Select
              className="joinClass"
              classNamePrefix="joinChild sbar "
              placeholder="Select your gender"
              options={sources?.map(item => ({ label: item, value: item }))}
              styles={colourStyles}
              isClearable={true}
              onChange={(value) => handleOnKnownSource(value)}
              // defaultValue={formData?.gender !== undefined ? formData?.gender : ''}
              value={formData?.gender !== undefined ? formData?.gender : ''}
              
            />
            {hasError(validataionErrors, "gender")}
          </div>

          <div className='w-full ' >

            <DatePicker
              className={'datepicker-custom-input-dob'}
              calendarClassName={'date-picker-custom'}
              clearIcon={null}
              calendarIcon={<CalendarIcon />}
              format="dd-MM-y"
              
              // activeStartDate={addYears(new Date(), -10)}
              defaultActiveStartDate={addYears(new Date(), -10)}
              onChange={(value) => { handleOnDateChange('dob', value) }}
              maxDate={(addYears(new Date(), -10))}
              value={formData?.dob ? new Date(formData?.dob) : ''}
              dayPlaceholder="Birth"
              monthPlaceholder="Of"
              yearPlaceholder="Date"

            />
            {hasError(validataionErrors, "dob")}


          </div>

          <div className='max-w-sm my-3' >
            <p className='text-center text-white text-[12px] textShad ' >Please note, your Instagram account must be a Business or Creator account in order to apply. You must at least 10,000 Followers on your application mayb be rejected</p>
          </div>
          <button onClick={moveToNextStep} type='submit' id='submit'
            style={{ boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px' }}
            className='i btn-anim bg-[#00B048] px-[60px] py-[10px] rounded-lg  mt-7 text-white font-museobb '>CONTINUE
          </button>

          <div className='mt-2 mb-8' >
            <div className='flex justify-center items-center mb-7 ' >
              <input onChange={changeInput} type="checkbox" id="tos" name="tos"value={formData?.tos}  checked={formData?.tos !== undefined ? formData?.tos : false}
                className='rounded-full border-none outline-none mr-3 cursor-pointer w-5 h-5 ' />
              <p className=' text-white text-xs textShad '><label htmlFor="tos">I have read and agree to the  <Link to="/terms" className='text-white hover:text-white underline hover:no-underline' > Terms & conditons</Link></label>
                <br></br>
                <span>{hasError(validataionErrors, "tos")}</span>
              </p>
            </div>

          </div>
        </form>

      </>
    )
  }

  const handleBack = () => {
    navigate("/join-dreamstar")
  }


  return (
    <>
      <CustomLoader visible={isLoading} />
      <div className='infJoinM relative max-w-screen min-h-screen font-museo bg-cover bg-center bg-no-repeat flex flex-col  items-center  '>
        <img alt="backbutton_image" onClick={handleBack} src={backButton} className=" cursor-pointer absolute top-5 left-8" />


        <div className='font-museob flex flex-col items-center justify-center md:mt-14 mt-20'>
          <p className='font-museob text-black text-4xl relative -bottom-3 ' >Join</p>
          <img alt="dreamstart_logo" src={dreamstars_logo} className="w-[50%] my-2  ml-8 " ></img>
          <p className='text-black text-4xl ' >I'm a <span className='font-museobb ' >Influencer</span></p>
        </div>

        {basicDetails()}


        <div className='absolute bottom-0' ><Footer colorClass="footerColor2" clas="footer" /></div>

      </div>

      
    </>
  )
}

export default InfluencerJoin


